<template>
<el-dialog :title="!dataForm.id ? '新增' : '修改'" width="70%" :append-to-body="true" :close-on-click-modal="false" :visible.sync="view.visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="code-type-dialog-form" size="small">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="零件编码" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="partCode" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.partCode" placeholder="零件编码"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="零件名称" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="partName" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.partName" placeholder="零件名称"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="单位" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="unit" style="margin-bottom: 0;">
                        <!-- <el-input v-model="dataForm.unit" placeholder="单位"></el-input> -->
                        <el-select v-model="dataForm.unit" filterable clearable  placeholder="请选择">
                            <el-option v-for="item in unitList" :key="item.code" :label="item.name" :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="正式订货数量" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="count" style="margin-bottom: 0;">
                        <ctl-number v-model="dataForm.count" :min="0" :max="999" label="描述文字"></ctl-number>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="到货时间" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="arriveDate" style="margin-bottom: 0;">
                        <el-date-picker v-model="dataForm.arriveDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间">
                        </el-date-picker>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="预测订货数量" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="preCount" style="margin-bottom: 0;">
                        <ctl-number v-model="dataForm.preCount" :min="0" :max="999" label="描述文字"></ctl-number>
                        <!-- <el-input v-model="dataForm.preCount" placeholder="预测订货数量"></el-input> -->
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="预测到货时间" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="preArriveDate" style="margin-bottom: 0;">
                        <el-date-picker v-model="dataForm.preArriveDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间">
                        </el-date-picker>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="备注" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="remark" style="margin-bottom: 0;">
                        <el-input type="textarea" :rows="3" v-model="dataForm.remark" placeholder="备注"></el-input>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>
    </el-form>
    <el-row>
        <el-col style="text-align: right">
            <el-button size="small" @click="view.visible = false">
                <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
            </el-button>
            <el-button size="small" type="primary" @click="dataFormSubmit()">
                <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;确定
            </el-button>
        </el-col>
    </el-row>
</el-dialog>
</template>

<script>
import {
    getPartById,
    createOrderPart,
    editOrderPart,
} from "@/controller/order";
import {
    getUnitList
} from '@/controller/systemData'
import CtlNumber from '@/views/common/ctl-number'
export default {
    data() {
        return {
            view: {
                visible: false,
                conheight: {
                    height: this.$store.state.common.documentClientDefaultHeight *
                        0.9 -
                        410 +
                        "px",
                    "overflow-y": "auto",
                },
            },
            unitList : [],
            viewData: {},
            dataForm: {
                id: 0,
                partCode: '',
                partName: '',
                unit: '',
                count: '',
                arriveDate: '',
                preCount: '',
                preArriveDate: '',
                remark: '',
                orderId: '',

            },
            // 开始
            dataRule: {
                name: [{
                    required: true,
                    message: "编码名称不能为空",
                    trigger: "blur",
                }, ],
                type: [{
                    required: true,
                    message: "编码类型不能为空",
                    trigger: "blur",
                }, ],
            },
        };
    },
    components: {
        CtlNumber
    },
    methods: {
        // 初始化
        init(id, orderId) {
            // debugger;
            this.dataForm.id = id || 0;
            this.dataForm.orderId = orderId;
            this.view.visible = true;
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    // 根据id查零件
                    getPartById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm = data.body;
                        }
                    });
                }
                this.getUnitList()
            });
        },
        getUnitList() {
            getUnitList({
                code: "",
                name: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            });
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let orderPartParams = {
                        id: this.dataForm.id || undefined,
                        orderId: this.dataForm.orderId,
                        'partCode': this.dataForm.partCode,
                        'partName': this.dataForm.partName,
                        'unit': this.dataForm.unit,
                        'count': this.dataForm.count,
                        'arriveDate': this.dataForm.arriveDate,
                        'preCount': this.dataForm.preCount,
                        'preArriveDate': this.dataForm.preArriveDate,
                        'remark': this.dataForm.remark,
                    };
                    if (this.dataForm.id) {
                        // 更新零件
                        editOrderPart(orderPartParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshOrderPartDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    } else {
                        // 创建零件
                        createOrderPart(orderPartParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshOrderPartDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                }
            });
        },
        getStyle() {
            return 'width: 120px; text-align: right'
        },
        getStyle2() {
            return 'width: 435.5px;'
        },
    },
};
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .code-type-dialog-form {
        width: 100%;
    }
}
</style>
